import { uniqBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import {
  CostCenterEmployeeWithStructuredAssignment,
  StructuredAssignment,
} from 'modules/cost_centers/components/Resources/Employees/types'

export type TextValue = {
  text?: string | null
  placeholder?: string
}

//****** PARENT LABELS ******//
export const familyLabelForParent = (
  item: CostCenterEmployeeWithStructuredAssignment
): TextValue | undefined => {
  const families = uniqBy(item.structuredAssignments.edges, 'jobCatalogFamilyName').filter(
    (value) => !!value.node.jobCatalogFamilyName
  )

  if (families.length === 1) {
    return {
      text: families[0]?.node.jobCatalogFamilyName ?? '',
    }
  }

  if (families.length > 1) {
    return {
      text: families.length.toString(),
    }
  }

  return {
    placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
  }
}

export const functionLabelForParent = (
  item: CostCenterEmployeeWithStructuredAssignment
): TextValue | undefined => {
  const functions = uniqBy(item.structuredAssignments.edges, 'jobCatalogFunctionName').filter(
    (value) => !!value.node.jobCatalogFunctionName
  )

  if (functions.length === 1) {
    return {
      text: functions[0]?.node.jobCatalogFunctionName,
    }
  }

  if (functions.length > 1) {
    return {
      text: functions.length.toString(),
    }
  }

  return {
    placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
  }
}

export const roleLabelForParent = (
  item: CostCenterEmployeeWithStructuredAssignment
): TextValue | undefined => {
  const roles = uniqBy(item.structuredAssignments.edges, 'jobCatalogRoleName').filter(
    (value) => !!value.node.jobCatalogRoleName
  )

  if (roles.length === 1) {
    return {
      text: roles[0]?.node.jobCatalogRoleName ?? '',
    }
  }

  if (roles.length > 1) {
    return {
      text: roles.length.toString(),
    }
  }

  return {
    placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
  }
}

//****** CHILD LABELS ******//
export const familyLabelForChild = (
  item: StructuredAssignment,
  parent: CostCenterEmployeeWithStructuredAssignment
): TextValue | undefined => {
  const families = uniqBy(parent.structuredAssignments.edges, 'jobCatalogFamilyName').filter(
    (value) => !!value.node.jobCatalogFamilyName
  )

  if (families.length === 1) {
    return {
      placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
    }
  }

  return {
    text: item.jobCatalogFamilyName,
  }
}

export const functionLabelForChild = (
  item: StructuredAssignment,
  parent: CostCenterEmployeeWithStructuredAssignment
): TextValue | undefined => {
  const functions = uniqBy(parent.structuredAssignments.edges, 'jobCatalogFunctionName').filter(
    (value) => !!value.node.jobCatalogFunctionName
  )

  if (functions.length === 1) {
    return {
      placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
    }
  }

  return {
    text: item.jobCatalogFunctionName,
  }
}

export const roleLabelForChild = (
  item: StructuredAssignment,
  parent: CostCenterEmployeeWithStructuredAssignment
): TextValue | undefined => {
  const roles = uniqBy(parent.structuredAssignments.edges, 'jobCatalogRoleName').filter(
    (value) => !!value.node.jobCatalogRoleName
  )

  if (roles.length === 1) {
    return {
      placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
    }
  }

  return {
    text: item.jobCatalogRoleName,
  }
}
